import { EntityRepository, Repository } from "typeorm";
import { DocumentsList } from "../documents-list.entity";

@EntityRepository(DocumentsList)
export class DocumentsListRepository extends Repository<DocumentsList>{

}